import React, { Component } from "react"
import { connect } from "react-redux"
import { pushRoute } from "../common/route"
import * as actions from "./actions"
import * as accountActions from "../account/actions"
import Source from "./Source"
import Dashboard from "./components/Dashboard"
import PWAInstallBanner from "../modals/PWAInstallBanner"

class DashboardContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      trackedView: false,
      sticky: false,
    }
  }

  componentDidUpdate = prevProps => {
    if (this.props.profile && this.props.profile !== prevProps.profile) {
      this.props.getProfileQuestions(this.props.profile.id)
    }

    // This call is dependent on brand so we already know we have it.
    if (
      (!prevProps.planInformation.office &&
        this.props.planInformation.office) ||
      (prevProps.planInformation && !this.props.planInformation)
    ) {
      this.props.getRecommendations()
    }

    if (!this.state.trackedView && this.props.brand.token) {
      Source.trackUserDashboardView(this.props.brand.token)
      this.setState({trackedView: true})
    }
  }

  setSticky = sticky => {
    if (sticky !== this.state.sticky) this.setState({ sticky: sticky })
  }

  goToProfile = () => pushRoute("/profile/", false)

  render() {
    return (
      <React.Fragment>
        <PWAInstallBanner />
        <Dashboard {...this.props} goToProfile={this.goToProfile} setSticky={this.setSticky} sticky={this.state.sticky} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const profile =
    state.account.hasSelf && state.account.profiles.length
      ? state.account.profiles.find(pro => pro.isself)
      : null

  return {
    brand: state.brand,
    loaded: state.dashboard.loaded.brand && state.dashboard.loaded.auth && state.dashboard.loaded.recommendations,
    loggedIn: state.auth.status.login.status,
    signedUp: state.auth.status.signup.status,
    planInformation: state.dashboard.planInformation,
    profile: profile,
    recommendations: state.dashboard.recommendations,
    profiles: state.account.profiles,
    predispositions: state.account.predispositions,
  }
}

const mapDispatchToProps = dispatch => ({
  setRecommendations: recommendations =>
    dispatch(actions.setRecommendations(recommendations)),
  getRecommendations: () => dispatch(actions.getRecommendations()),
  getProfileQuestions: id => dispatch(accountActions.getProfileQuestions(id)),
  getPlanInformation: () => dispatch(actions.getPlanInformation()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)



// WEBPACK FOOTER //
// ./assets/dashboard/index.js